import { render, staticRenderFns } from "./BillboardConifg.vue?vue&type=template&id=231e15e0&scoped=true&"
import script from "./BillboardConifg.vue?vue&type=script&lang=js&"
export * from "./BillboardConifg.vue?vue&type=script&lang=js&"
import style0 from "./BillboardConifg.vue?vue&type=style&index=0&id=231e15e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231e15e0",
  null
  
)

export default component.exports